module.exports = __webpack_public_path__ + "media/questions/green-arrow-32e0844f.png";